import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import { EXCHANGE_COUNTRY, TEXT_LOADING } from '../../models/Onboarding';

@Component({
  selector: 'app-loading-manteca',
  standalone: true,
  imports: [LottieComponent],
  template: `
    <ng-lottie [options]="options" />
    @if(exchangeCountry && texts?.length){
    <div class="carousel-container">
      <p class="title">¿Sabías qué?</p>
      <div [@textAnimation]="currentIndex" class="carousel-text">
        {{ texts[currentIndex] }}
      </div>
    </div>
    }
  `,
  styles: [
    `
      :host {
        height: 85%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
      }
      @media (min-width: 1024px) {
        :host {
          max-height: 28rem;
          width: 40rem;
          justify-content: center;
          height: 100%;
          gap: 8rem;
          margin: unset;
        }
      }
      @media (max-width: 768px) {
        ng-lottie {
          width: 85%;
          height: 100%;
        }
      }
      .carousel-container {
        display: flex;
        flex-direction: column;
        padding: 0.6rem 1rem;
        box-shadow: 0px 0px 2px 1px #2828281a, 0px 2px 4px 0px #2828281a;
        margin: 0 2rem;
        border-radius: 0.4rem;
        gap: 0.4rem;
        height: fit-content;
        .title {
          font-size: 1rem;
          color: #cc8a02;
          font-weight: 500;
        }
      }
      .carousel-text {
        color: #282828;
        font-size: 1rem;
        font-weight: 500;
      }
    `,
  ],
  animations: [
    trigger('textAnimation', [
      transition(':increment', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':decrement', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
    ]),
  ],
})
export class LoadingComponent implements OnInit, OnDestroy {
  @Input() exchangeCountry: EXCHANGE_COUNTRY;
  options: AnimationOptions = {
    path: '/assets/animations/dashboard-loader/loading-manteca.json',
  };
  texts = [];

  currentIndex = 0;
  private intervalId: ReturnType<typeof setInterval> | null = null;

  ngOnInit() {
    if (this.exchangeCountry) {
      this.texts = TEXT_LOADING[this.exchangeCountry];
      this.intervalId = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.texts?.length;
      }, 5000);
    }
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
